const actionTypes = {
  setAwaitingFileSelection: 'SET_AWAITING_FILE_SELECTION',
  setFiles: 'SET_FILES',
  setFieldValue: 'SET_FIELD_VALUE',
  setCopyFieldValue: 'SET_COPY_FIELD_VALUE',
  updateFileReadyToUploadFlag: 'UPDATE_FILE_READY_TO_UPLOAD_FLAG',
  updateFileUploadProgress: 'UPDATE_FILE_UPLOAD_PROGRESS',
  updateFileStatus: 'UPDATE_FILE_STATUS',
  updateFileError: 'UPDATE_FILE_ERROR',
  removeFile: 'REMOVE_FILE',
  setCheckedList: 'SET_CHECKED_LIST',
  abortUpload: 'ABORT_UPLOAD',
  setUploadInfo: 'SET_UPLOAD_INFO',
  setRetryStatus: 'SET_RETRY_STATUS',
};

export default actionTypes;
